"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MELDUNGEN_WRITE_ROLES = exports.MELDUNGEN_READ_ROLES = void 0;
const Roles_1 = require("../enums/Roles");
exports.MELDUNGEN_READ_ROLES = [Roles_1.Roles.CallmartOSP, Roles_1.Roles.CallmartWFM, Roles_1.Roles.CallmartWTM];
exports.MELDUNGEN_WRITE_ROLES = [Roles_1.Roles.CallmartOSP, Roles_1.Roles.CallmartWFM];
